const GPS_OFFLINE_STATUSES = new Set(["stale", "offline"]);
const ROUTE_DEVIATION_STATUSES = new Set(["out_of_the_way", "custom_out_of_route"]);

function hasRouteDeviation(record) {
  const configuredAlert = Boolean(record?.monitoringBooking) &&
    record.monitoringBooking.gpsAlertConfiguration?.alertsEnabled !== false &&
    record?.routeDeviationAlert?.active === true &&
    record?.routeDeviationAlert?.type === "route_deviation";
  const tracking = record?.monitoringBooking?.tracking || {};
  return configuredAlert || ROUTE_DEVIATION_STATUSES.has(
    String(tracking.status || tracking.mode || "").toLowerCase()
  );
}

function hasPowerDisconnected(record) {
  return record?.powerCutAlert?.active === true ||
    record?.powerCut === true || record?.powerDisconnected === true;
}

export function getMonitoringSeverity(record) {
  const gpsOffline = GPS_OFFLINE_STATUSES.has(String(record?.gpsStatus || "").toLowerCase());
  const powerDisconnected = hasPowerDisconnected(record);
  const routeDeviation = hasRouteDeviation(record);

  if (gpsOffline) {
    return { key: "critical", label: "GPS Offline", gpsOffline, powerDisconnected, routeDeviation };
  }
  if (powerDisconnected) {
    return {
      key: "power",
      label: routeDeviation ? "Route Deviation + Power Disconnected" : "Power Disconnected",
      gpsOffline,
      powerDisconnected,
      routeDeviation,
    };
  }
  if (routeDeviation) {
    return { key: "warning", label: "Route Deviation", gpsOffline, powerDisconnected, routeDeviation };
  }
  return { key: "normal", label: null, gpsOffline, powerDisconnected, routeDeviation };
}

export function getNotificationSeverity(notification) {
  const type = String(notification?.type || "").toLowerCase();
  if (type.startsWith("gps_offline")) return "critical";
  if (type.startsWith("gps_power_cut") || type.startsWith("gps_power_disconnected")) return "power";
  if (type.startsWith("gps_route_deviation")) return "warning";
  return null;
}
